import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NavigationRoot } from "./navigation/NavigationRoot";
import { LoginApp } from "./pages/LoginApp/LoginApp";
import { useGoogleAuthContext } from "./contexts/GoogleAuthContext";
import { Loading } from "./components/Loading";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";

function App() {
  const { authenticated, loading } = useGoogleAuthContext();
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        {loading ? (
          <Loading />
        ) : authenticated ? (
          <NavigationRoot />
        ) : (
          <LoginApp />
        )}
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
